module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map-marker-detials"
  }, [(_vm.title === 'From') ? _c('img', {
    attrs: {
      "src": "/static/icons/Asset 4.png",
      "width": "16px",
      "alt": "map marker from"
    }
  }) : _c('img', {
    attrs: {
      "src": "/static/icons/Asset 6.png",
      "width": "16px",
      "alt": "map marker to"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v(_vm._s(_vm.title) + ":")]), _c('br'), _vm._v("\n    " + _vm._s(_vm.address) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-f20c1ee6"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/JobLocation.vue
// module id = 1087
// module chunks = 0